import { colors } from '@material-ui/core';

const white = '#FFFFFF';

// Soft modern blue — clear color without looking black
const brand = {
	main: '#3b82f6',
	dark: '#2563eb',
	light: '#93c5fd',
	muted: '#64748b'
};

export default {
	primary: {
		contrastText: white,
		dark: brand.dark,
		main: brand.main,
		light: brand.light
	},
	secondary: {
		contrastText: white,
		dark: '#475569',
		main: brand.muted,
		light: '#94a3b8'
	},
	error: {
		contrastText: white,
		dark: colors.red[900],
		main: colors.red[600],
		light: colors.red[400]
	},
	text: {
		primary: '#1e293b',
		secondary: '#64748b',
		link: brand.dark
	},
	link: brand.dark,
	icon: '#64748b',
	// Page bg options (pick one):
	// A Paper      #F9FAFB — near-white, airiest
	// B Cool Slate #F1F5F9 — clearer blue-gray
	// C Soft Azure #EEF2F7 — cooler wash, more contrast vs cards
	// D Warm Stone #F5F5F4 — neutral warm (not cream)
	// E Mist       #F8FAFC — soft cool white (current)
	background: {
		default: '#F8FAFC',
		paper: white
	},
	divider: colors.grey[200]
};
